<template>
	<div>
		<div>
			<simpletable
				:data="myData"
				:is-loading="isLoading"
				@editAction="editTable($event)"
				@searchtext="searchTerm = $event"
			/>
			<modal v-if="modalVisible" title="Editar" @closemodal="closeModal()">
				<template v-slot:modalcontent>
					<div class="container-slot-modal">
						<b-field custom-class="is-small" label="Name">
							<b-input v-model="modalSelectedData.descricao" size="is-small" />
						</b-field>
						<b-field custom-class="is-small" label="Status">
							<b-switch
								v-model="modalSelectedData.status"
								:true-value="1"
								:false-value="0"
								size="is-small"
							>
								{{ modalSelectedData.status === 0 ? 'Inativo' : 'Ativo' }}
							</b-switch>
						</b-field>
						<b-field custom-class="is-small" label="Validar prazo médio">
							<b-switch
								v-model="modalSelectedData.validdaysavg"
								:true-value="1"
								:false-value="0"
								size="is-small"
							>
								{{ modalSelectedData.validdaysavg === 0 ? 'Inativo' : 'Ativo' }}
							</b-switch>
						</b-field>
						<b-field custom-class="is-small" label="Id Integração">
							<b-input v-model="modalSelectedData.integracao_id" size="is-small" />
						</b-field>
						<div class="actions-button">
							<b-button
								class="buttons-center"
								expanded
								size="is-small"
								type="is-success"
								outlined
								@click="saveAction()"
							>
								Salvar
							</b-button>
							<b-button
								expanded
								class="buttons-center"
								size="is-small"
								type="is-danger"
								outlined
								@click="closeModal()"
							>
								Cancelar
							</b-button>
						</div>
					</div>
				</template>
			</modal>

			<modal v-if="modalAddCondPagamento" title="Adicionar" @closemodal="closeModalAdd()">
				<template v-slot:modalcontent>
					<div class="container-slot-modal">
						<b-field label="Name">
							<b-input v-model="addCondPagamentoData.descricao" />
						</b-field>
						<b-field label="Status">
							<b-switch v-model="addCondPagamentoData.status" :true-value="1" :false-value="0">
								{{ addCondPagamentoData.status === 0 ? 'Inativo' : 'Ativo' }}
							</b-switch>
						</b-field>
						<b-field label="Validar prazo médio">
							<b-switch
								v-model="addCondPagamentoData.validdaysavg"
								:true-value="1"
								:false-value="0"
							>
								{{ addCondPagamentoData.validdaysavg === 0 ? 'Inativo' : 'Ativo' }}
							</b-switch>
						</b-field>
						<b-field label="Id Integração">
							<b-input v-model="addCondPagamentoData.integracao_id" />
						</b-field>
						<div class="actions-button">
							<b-button
								class="buttons-center"
								type="is-success"
								outlined
								size="is-small"
								expanded
								@click="addAction()"
							>
								Adicionar
							</b-button>
							<b-button
								class="buttons-center"
								type="is-danger"
								outlined
								size="is-small"
								expanded
								@click="closeModalAdd()"
							>
								Cancelar
							</b-button>
						</div>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import simpletable from '../../layout/components/table/simple';
import modal from '../../layout/components/modal/centered';
import * as ecAxios from '../../util/ecAxios';

export default {
	components: {
		simpletable,
		modal,
	},
	data() {
		return {
			isSwitchedCustom: 'Inativo',
			name: '',
			addCondPagamentoData: {
				descricao: '',
				associado_id: 1,
				integracao_id: 0,
				status: 0,
				validdaysavg: 0,
			},
			modalVisible: false,
			data: [],
			searchTerm: '',
			modalSelectedData: {},
			isLoading: false,
		};
	},
	computed: {
		modalAddCondPagamento() {
			return this.$store.getters.getModalCondPagamento;
		},
		myData() {
			const searchData = this.searchTerm;
			if (searchData) {
				return this.data.filter((item) => this.filterSearch(item.descricao));
			}
			return this.data;
		},
	},
	created() {
		this.getAllData();
	},
	methods: {
		async addAction() {
			if (this.addCondPagamentoData.descricao !== '') {
				await ecAxios
					.connection()
					.post(
						`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_COND_PAGAMENTO_SALVAR}`,
						this.addCondPagamentoData
					)
					.then((response) => {
						if (response.data.error === 0) {
							this.$store.dispatch('setModalCondPagamento', false);
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
		},
		closeModalAdd() {
			this.$store.dispatch('setModalCondPagamento', false);
		},
		filterSearch(field) {
			if (typeof field === 'number') {
				// eslint-disable-next-line no-param-reassign
				field = field.toString();
			}
			if (field === null) {
				// eslint-disable-next-line no-param-reassign
				field = '';
			}
			return field.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
		},
		async getAllData() {
			this.isLoading = true;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_COND_PAGAMENTO}`)
				.then((response) => {
					if (response.data.error === 0) {
						this.data = [];
						this.data = response.data.condpgtos;
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
			this.isLoading = false;
		},
		editTable(selected) {
			this.modalSelectedData = selected;
			this.modalVisible = !this.modalVisible;
		},
		async saveAction() {
			await ecAxios
				.connection()
				.put(
					`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_COND_PAGAMENTO_SALVAR}${this.modalSelectedData.id}`,
					{
						associado_id: this.modalSelectedData.associado_id,
						descricao: this.modalSelectedData.descricao,
						id: this.modalSelectedData.id,
						integracao_id: this.modalSelectedData.integracao_id,
						status: this.modalSelectedData.status,
						validdaysavg: this.modalSelectedData.validdaysavg,
					}
				)
				.then((response) => {
					if (response.data.error === 0) {
						this.$buefy.notification.open({
							message: response.data.message,
							type: 'is-success',
						});
						this.getAllData();
						this.modalVisible = !this.modalVisible;
					} else {
						this.$buefy.notification.open({
							message: response.data.error,
							type: 'is-danger',
						});
					}
				})
				.catch();
		},
		closeModal() {
			this.modalVisible = !this.modalVisible;
		},
	},
};
</script>

<style scoped>
.actions-button {
	display: flex;
	width: 100%;
	height: 100px;
	align-items: center;
	justify-content: center;
}

.container-slot-modal {
	width: 100%;
	flex-direction: column;
	display: flex;
}
.buttons-center {
	margin: 10px;
}
</style>

